import axios from "axios";

const api = axios.create({
  // baseURL: "https://localhost:7001/api",
  // baseURL: process.env.REACT_APP_API_URL,
  
  baseURL :
  process.env.NODE_ENV === "development"
    ? "https://localhost:7001/api"
    : "http://www.pesnoslovnik.eu/services/api"
});

// Attach token if exists
api.interceptors.request.use(config => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle unauthorized globally
export const setupAxiosInterceptor = (navigate) => {
  api.interceptors.response.use(
    res => res,
    err => {
      if (err.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/login");
      }
      return Promise.reject(err);
    }
  );
};

export default api;